await themeComponent(theme.components['mc-element'], false);

class McAccordion extends McElement {
    constructor(){
        super();
    }

    connectedCallback(){
        this.items = this.querySelectorAll('mc-accordion-item');
        this.addEventListener('item:open', (event) => {
            this.items.forEach(item => {
                if(item.id != event.data){
                    item.deactivate();
                }
            })
        })
    }
}
if(!window.customElements.get('mc-accordion')){
	window.customElements.define('mc-accordion', McAccordion);
}
window.McAccordion = McAccordion;

class McAccordionItem extends McElement {
    constructor(){
        super();
    }

    connectedCallback(){
        this.accordion = this.closest('mc-accordion');
        if(this.dataset.open != undefined){
            setTimeout(() => this.querySelector('mc-btn').dispatchEvent(new Event('external:trigger')), 50);
        }
    }
}
if(!window.customElements.get('mc-accordion-item')){
	window.customElements.define('mc-accordion-item', McAccordionItem);
}
window.McAccordionItem = McAccordionItem;